// api/journalAPI.ts
import { firebaseAuth } from "../firebase/auth";
import { JournalEntry } from "../types/journal";

const API_URL = import.meta.env.VITE_API_URL;

class JournalAPI {
  private async request(endpoint: string, options: RequestInit = {}) {
    const idToken = await firebaseAuth.getIdToken();
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
      ...options.headers,
    };

    const response = await fetch(`${API_URL}${endpoint}`, {
      ...options,
      headers,
    });

    if (!response.ok && response.status !== 400) {
      const errorText = await response.text();
      throw new Error(errorText || "Request failed");
    }

    return response.json();
  }

  async getAnalysisByDate(now) {
    try {
      const response = await this.request(`/api/journal/analysis/${now.getTime()}`);
      return response;
    } catch (error) {

      console.error("Error fetching data for test day:", error);
      throw error;
    }
  }

  async getEntries(startDate: Date): Promise<JournalEntry[]> {
    const entries = await this.request(
      `/api/journal/${startDate.toISOString()}`
    );
    return entries.map(this.parseEntryDates);
  }

  async createEntry(data: {
    date: Date;
    type: "morning" | "evening";
    content: string;
    metrics: Record<string, number>;
  }): Promise<JournalEntry> {
    const response = await this.request("/api/journal", {
      method: "POST",
      body: JSON.stringify({
        ...data,
        date: data.date.toISOString(),
      }),
    });

    return this.parseEntryDates(response);
  }

  async updateEntry(data: {
    date: Date;
    type: "morning" | "evening";
    content: string;
    metrics: Record<string, number>;
  }): Promise<JournalEntry> {
    const response = await this.request(
      `/api/journal/${data.date.toISOString()}/${data.type}`,
      {
        method: "PUT",
        body: JSON.stringify({
          content: data.content,
          metrics: data.metrics,
        }),
      }
    );

    return this.parseEntryDates(response);
  }

  private parseEntryDates(entry: any): JournalEntry {
    return {
      ...entry,
      date: new Date(entry.date),
      createdAt: new Date(entry.createdAt),
      updatedAt: new Date(entry.updatedAt),
    };
  }
}

export const journalAPI = new JournalAPI();
